import { DynamicStoreInterface } from '@as-react/common-types';
import { IModuleStore } from 'redux-dynamic-modules-core';

export class DynamicStore implements DynamicStoreInterface {
  private _store: IModuleStore<unknown> | null = null;

  getStore<T1>(): IModuleStore<T1> {
    return this._store as IModuleStore<T1>;
  }

  setStore<T1>(store: IModuleStore<T1>) {
    this._store = store;
  }
}
